import React from "react";
import { Col, Form, Row, Upload, Button, message, Tooltip } from "antd";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnSubtitle from "../common/adnSubtitle/AdnSubtitle";
import AdnCard from "../common/adnCard/AdnCard";
import AdnInput from "../common/adnInput/AdnInput";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import { getAuthenticatedUserIdWithToken } from "../../api/ApiUtils";
import { tokenKey } from "../../api/OAuth";
import AdnToolTip from "../common/adnToolTip/AdnToolTip";
import "./ContractProposal.css";
import { dateFormat } from "../common/GeneralConfigurations";

import {
    LoadingOutlined,
    UploadOutlined,
    InfoCircleOutlined,
    EuroOutlined,
    FilePptOutlined,
    PercentageOutlined,
} from "@ant-design/icons";
import { NameValidation } from "../common/GeneralConfigurations";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import Text from "antd/lib/typography/Text";
import AdnLanguageSlider from "../common/adnLanguageSlider/AdnLanguageSlider";

const ContractProposalForm = ({
    form,
    title,
    loading,
    readOnly,
    fieldsUnsaved,
    managers,
    workPlaces,
    contractTypes,
    careerLevels,
    handleInputChange,
    handleBlurName,
    handleManager,
    handleContractType,
    beforeUploadExcel,
    handleUploadClick,
    excelLoading,
    excelName,
    isExcelUploaded,
    isEnglish,
    onLanguageSwitch,
    handleGeneratePWP,
    pptxLoading,
    handleCancel,
    onFinish,
    submitLoading,
    addNewContractProposal,
}) => {
    return (
        <>
            <AdnPageTitle title={title} />
            <AdnCard loading={loading}>
                <Form
                    onValuesChange={handleInputChange}
                    form={form}
                    name="advanced_search"
                    layout="vertical"
                    className="ant-advanced-search-form"
                    onFinish={onFinish}
                >
                    <Row>
                        {title == "Edit Financial Proposal" ? (
                            <>
                                <Col span={21}>
                                    <AdnSubtitle text={"Personal Info"} />
                                </Col>

                                <Col span={3}>
                                    <AdnAddButton
                                        type="Primary"
                                        handleClick={addNewContractProposal}
                                        text="New Financial Proposal"
                                    ></AdnAddButton>
                                </Col>
                            </>
                        ) : (
                            <Col>
                                <AdnSubtitle text={"Personal Info"} />
                            </Col>
                        )}
                    </Row>
                    <Row gutter={16}>
                        <Col span={8} key={"name"} className="gutter-row">
                            <AdnInput
                                label="Name"
                                name="name"
                                maxLength={50}
                                placeholder={"Name"}
                                handleBlur={handleBlurName}
                                rules={NameValidation}
                            />
                        </Col>

                        <Col span={8} key={"managerId"} className="gutter-row">
                            <AdnDropdown
                                placeholder={"Manager"}
                                name="managerId"
                                value={getAuthenticatedUserIdWithToken(
                                    localStorage.getItem(tokenKey)
                                )}
                                handleChange={(id) => {
                                    handleManager(id);
                                }}
                                label="Manager"
                                options={managers}
                                rules={[{ required: true, message: "Manager is required" }]}
                            />
                        </Col>

                        <Col span={8} key={"workPlaceId"} className="gutter-row">
                            <AdnDropdown
                                placeholder={"Location"}
                                options={workPlaces}
                                name="workPlaceId"
                                label="Location"
                                rules={[{ required: true, message: "Location is required" }]}
                            />
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={8} key={"startDate"} className="gutter-row">
                            <AdnDatePicker
                                label="Start Date"
                                name="startDate"
                                placeholder={"Start Date"}
                                format={dateFormat}
                            />
                        </Col>

                        <Col span={8} key={"contractTypeId"} className="gutter-row">
                            <AdnDropdown
                                placeholder={"Contract Type"}
                                name="contractTypeId"
                                label="Contract Type"
                                handleChange={(id) => {
                                    handleContractType(id);
                                }}
                                options={contractTypes}
                                rules={[
                                    { required: true, message: "Contract type is required" },
                                ]}
                            />
                        </Col>

                        <Col span={8} key={"carrearLevelId"} className="gutter-row">
                            <AdnDropdown
                                placeholder={"Career Level"}
                                name="carrearLevelId"
                                label="Career Level"
                                options={careerLevels}
                                rules={[
                                    { required: true, message: "Career level is required" },
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <AdnSubtitle text={"Conditions"} />
                    </Row>
                    <Row>
                        <Col span={5} key={"readExcel"} className="gutter-row">
                            <Upload
                                onChange={handleUploadClick}
                                name="uploadExcelProposal"
                                label={"Upload Excel"}
                                beforeUpload={beforeUploadExcel}
                                customRequest={(options) => console.log(options)}
                                showUploadList={false}
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            >
                                <Button
                                    className="ant-btn-upl"
                                    icon={excelLoading ? <LoadingOutlined /> : <UploadOutlined />}
                                >
                                    Upload Excel
                                </Button>
                            </Upload>

                            <AdnToolTip
                                title={
                                    "File must have sheet name 'Cálculo de Projeto', Salary, Net Salary, Lunch Allowance and Yearly Net Salary greater than 0."
                                }
                            ></AdnToolTip>
                        </Col>
                    </Row>
                    <Row className="marginBotton"></Row>
                    <Row>
                        {excelName ==
                            "Invalid file. Was not found Sheet Name: 'Cálculo de Projeto'." ||
                            excelName ==
                            "Salary, Net Salary, LunchAllowance or Yearly Net Salary are invalid. Please upload a valid contract proposal Excel file." ? (
                            <Text style={{ color: "red" }}> {excelName}</Text>
                        ) : (
                            <Text style={{ color: "green" }}> {excelName}</Text>
                        )}
                    </Row>
                    <></>
                    <Row></Row>
                    {isExcelUploaded == true && (
                        <>
                            <Row gutter={16}>
                                <Col span={4} key={"salary"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Salary"
                                        name="salary"
                                        maxLength={50}
                                        placeholder={"Salary"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                            {
                                                pattern: /[1-9]/,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"netSalary"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Net Salary"
                                        name="netSalary"
                                        maxLength={50}
                                        placeholder={"Net Salary"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                            {
                                                pattern: /[1-9]/,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"yearlyNetSalary"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Yearly Net Salary"
                                        name="yearlyNetSalary"
                                        maxLength={50}
                                        placeholder={"Yearly Net Salary"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"cpsValuePerDay"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="CPS Day Value"
                                        name="cpsValuePerDay"
                                        maxLength={50}
                                        placeholder={"CPS Day Value"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                            {
                                                pattern: /[1-9]/,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"lunchAllowance"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        placeholder="Lunch Allowance"
                                        label="Lunch Allowance"
                                        name={"lunchAllowance"}
                                        maxLength={50}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                            {
                                                pattern: /[1-9]/,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>

                                <Col span={4} key={"lunchAllowanceM"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        name={"mensalLunchAllowance"}
                                        type={"number"}
                                        label={
                                            <>
                                                Mensal L. Allowance
                                                <>
                                                    <Tooltip
                                                        title={`${form.getFieldValue(
                                                            "lunchAllowance"
                                                        )} x 21`}
                                                    >
                                                        <InfoCircleOutlined
                                                            style={{ marginLeft: "10px" }}
                                                        />
                                                    </Tooltip>
                                                </>
                                            </>
                                        }
                                        maxLength={50}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>

                                <Col span={4} key={"irs"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<PercentageOutlined />}
                                        type={"number"}
                                        label="Gross IRS"
                                        name="irs"
                                        maxLength={50}
                                        placeholder={"Gross IRS"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"irsAllowance"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<PercentageOutlined />}
                                        type={"number"}
                                        label="IRS Allowance"
                                        name="irsAllowance"
                                        maxLength={50}
                                        placeholder={"IRS Allowance"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col
                                    span={4}
                                    key={"capitalizationInsurance"}
                                    className="gutter-row"
                                >
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Capitalization Insurance"
                                        name="capitalizationInsurance"
                                        maxLength={50}
                                        placeholder={"Capitalization Insurance"}
                                    />
                                </Col>

                                <Col span={4} key={"technologyExpenses"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Technology Expenses"
                                        name="technologyExpenses"
                                        maxLength={50}
                                        placeholder={"Technology Expenses"}
                                    />
                                </Col>

                                <Col span={4} key={"dayCareCheck"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Day Care Check"
                                        name="dayCareCheck"
                                        maxLength={50}
                                        placeholder={"Day Care Check"}
                                    />
                                </Col>

                                <Col span={4} key={"vehicleLeasing"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Vehicle Leasing"
                                        name="vehicleLeasing"
                                        maxLength={50}
                                        placeholder={"Vehicle Leasing"}
                                    />
                                </Col>

                                <Col span={4} key={"fuelVaucher"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Fuel Vaucher"
                                        name="fuelVaucher"
                                        maxLength={50}
                                        placeholder={"Fuel Vaucher"}
                                    />
                                </Col>
                                <Col span={4} key={"expenses"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Expenses"
                                        name="expenses"
                                        maxLength={50}
                                        placeholder={"Expenses"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"healthCare"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Health Care"
                                        name="healthCare"
                                        maxLength={50}
                                        placeholder={"Health Care"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col span={4} key={"laptopAndPhone"} className="gutter-row">
                                    <AdnInput
                                        readOnly={readOnly}
                                        addonAfter={<EuroOutlined />}
                                        type={"number"}
                                        label="Laptop/Phone"
                                        name="laptopAndPhone"
                                        maxLength={50}
                                        placeholder={"Laptop/Phone"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "Field is required",
                                            },
                                        ]}
                                    />
                                </Col>
                            </Row>
                            {isExcelUploaded && !fieldsUnsaved && (
                                <Row className="gutter-row">
                                    <Col>
                                        <AdnLanguageSlider
                                            isEnglish={isEnglish}
                                            onLanguageSwitch={onLanguageSwitch}
                                        />
                                        <Button
                                            className="ant-btn-upl"
                                            icon={<FilePptOutlined />}
                                            style={{ marginTop: 25 }}
                                            type="secondary"
                                            onClick={handleGeneratePWP}
                                            disabled={fieldsUnsaved}
                                            loading={pptxLoading}
                                        >
                                            Generate PPTX
                                        </Button>

                                        <AdnToolTip
                                            title={
                                                "Generates a Power Point with the Finantial Proposal."
                                            }
                                        ></AdnToolTip>

                                        {fieldsUnsaved && (
                                            <Text style={{ color: "red", marginLeft: 10 }}>
                                                Unsaved data. Cannot generate PowerPoint.
                                            </Text>
                                        )}
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}
                    <Row gutter={16}>
                        <Col span={8} offset={16} className="gutter-row">
                            <AdnFormOptions
                                handleCancel={handleCancel}
                                loading={submitLoading}
                            />
                        </Col>
                    </Row>
                </Form>
            </AdnCard>
        </>
    );
};

export default ContractProposalForm;
